import React from "react";
import { Redirect } from "react-router-dom";

// Pages Component
import Chat from "../pages/page-themes/Chat/Chat";

// Pages File Manager
import FileManager from "../pages/page-themes/FileManager/index";

// Pages Calendar
import Calendar from "../pages/page-themes/Calendar/index";

// User profile
import UserProfile from "../pages/page-themes/Authentication/UserProfile";

//Ecommerce Pages
import EcommerceProducts from "../pages/page-themes/Ecommerce/EcommerceProducts/index";
import EcommerceProductDetail from "../pages/page-themes/Ecommerce/EcommerceProducts/EcommerceProductDetail";
import EcommerceOrders from "../pages/page-themes/Ecommerce/EcommerceOrders/index";
import EcommerceCustomers from "../pages/page-themes/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/page-themes/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/page-themes/Ecommerce/EcommerceCheckout";
import EcommerceShops from "../pages/page-themes/Ecommerce/EcommerceShops/index";
import EcommerceAddProduct from "../pages/page-themes/Ecommerce/EcommerceAddProduct";

//Email
import EmailInbox from "../pages/page-themes/Email/email-inbox";
import EmailRead from "../pages/page-themes/Email/email-read";
import EmailBasicTemplte from "../pages/page-themes/Email/email-basic-templte";
import EmailAlertTemplte from "../pages/page-themes/Email/email-template-alert";
import EmailTemplateBilling from "../pages/page-themes/Email/email-template-billing";

// Authentication related pages
import Login from "../pages/page-themes/Authentication/Login";
import Logout from "../pages/page-themes/Authentication/Logout";
import ForgetPwd from "../pages/page-themes/Authentication/ForgetPassword";

// Inner Authentication
import Login1 from "../pages/page-themes/AuthenticationInner/Login";
import Login2 from "../pages/page-themes/AuthenticationInner/Login2";
import Register1 from "../pages/page-themes/AuthenticationInner/Register";
import Register2 from "../pages/page-themes/AuthenticationInner/Register2";
import Recoverpw from "../pages/page-themes/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/page-themes/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/page-themes/AuthenticationInner/ForgetPassword";
import ForgetPwd2 from "../pages/page-themes/AuthenticationInner/ForgetPwd2";
import LockScreen from "../pages/page-themes/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/page-themes/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/page-themes/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/page-themes/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/page-themes/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/page-themes/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/page-themes/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/page-themes/AuthenticationInner/auth-two-step-verification-2";

// Dashboard
// import Dashboard from "../pages/page-themes/Dashboard/index";
import DashboardSaas from "../pages/page-themes/Dashboard-saas/index";
import DashboardBlog from "../pages/page-themes/Dashboard-blog/index";

// Charts
import ChartApex from "../pages/page-themes/Charts/Apexcharts";
import ChartistChart from "../pages/page-themes/Charts/ChartistChart";
import ChartjsChart from "../pages/page-themes/Charts/ChartjsChart";
import EChart from "../pages/page-themes/Charts/EChart";
import SparklineChart from "../pages/page-themes/Charts/SparklineChart";
import ChartsKnob from "../pages/page-themes/Charts/charts-knob";
import ReCharts from "../pages/page-themes/Charts/ReCharts";

// Maps
import MapsGoogle from "../pages/page-themes/Maps/MapsGoogle";
import MapsVector from "../pages/page-themes/Maps/MapsVector";
import MapsLeaflet from "../pages/page-themes/Maps/MapsLeaflet";

//Icons
import IconBoxicons from "../pages/page-themes/Icons/IconBoxicons";
import IconDripicons from "../pages/page-themes/Icons/IconDripicons";
import IconMaterialdesign from "../pages/page-themes/Icons/IconMaterialdesign";
import IconFontawesome from "../pages/page-themes/Icons/IconFontawesome";

//Tables
import BasicTables from "../pages/page-themes/Tables/BasicTables";
import DatatableTables from "../pages/page-themes/Tables/DatatableTables";
import ResponsiveTables from "../pages/page-themes/Tables/ResponsiveTables";
import EditableTables from "../pages/page-themes/Tables/EditableTables";
import DragDropTables from "../pages/page-themes/Tables/DragDropTables";

// Forms
import FormElements from "../pages/page-themes/Forms/FormElements/index";
import FormLayouts from "../pages/page-themes/Forms/FormLayouts";
import FormAdvanced from "../pages/page-themes/Forms/FormAdvanced";
import FormEditors from "../pages/page-themes/Forms/FormEditors";
import FormValidations from "../pages/page-themes/Forms/FormValidations";
import FormMask from "../pages/page-themes/Forms/FormMask";
import FormRepeater from "../pages/page-themes/Forms/FormRepeater";
import FormUpload from "../pages/page-themes/Forms/FormUpload";
import FormWizard from "../pages/page-themes/Forms/FormWizard";
import FormXeditable from "../pages/page-themes/Forms/FormXeditable";
import DualListbox from "../pages/page-themes/Forms/DualListbox";

//Ui
import UiAlert from "../pages/page-themes/Ui/UiAlert";
import UiButtons from "../pages/page-themes/Ui/UiButtons";
import UiCards from "../pages/page-themes/Ui/UiCards";
import UiCarousel from "../pages/page-themes/Ui/UiCarousel";
import UiColors from "../pages/page-themes/Ui/UiColors";
import UiDropdown from "../pages/page-themes/Ui/UiDropdown";
import UiGeneral from "../pages/page-themes/Ui/UiGeneral";
import UiGrid from "../pages/page-themes/Ui/UiGrid";
import UiImages from "../pages/page-themes/Ui/UiImages";
import UiLightbox from "../pages/page-themes/Ui/UiLightbox";
import UiModal from "../pages/page-themes/Ui/UiModal";
import UiProgressbar from "../pages/page-themes/Ui/UiProgressbar";
import UiSweetAlert from "../pages/page-themes/Ui/UiSweetAlert";
import UiTabsAccordions from "../pages/page-themes/Ui/UiTabsAccordions";
import UiTypography from "../pages/page-themes/Ui/UiTypography";
import UiVideo from "../pages/page-themes/Ui/UiVideo";
import UiSessionTimeout from "../pages/page-themes/Ui/UiSessionTimeout";
import UiRating from "../pages/page-themes/Ui/UiRating";
import UiRangeSlider from "../pages/page-themes/Ui/UiRangeSlider";
import UiNotifications from "../pages/page-themes/Ui/ui-notifications";
import UiToast from "../pages/page-themes/Ui/UiToast";
import UiOffCanvas from "../pages/page-themes/Ui/UiOffCanvas";
import Breadcrumb from "../pages/page-themes/Ui/UiBreadcrumb";
import UiPlaceholders from "../pages/page-themes/Ui/UiPlaceholders";

//Pages
import PagesStarter from "../pages/page-themes/Utility/pages-starter";
import PagesMaintenance from "../pages/page-themes/Utility/pages-maintenance";
import PagesComingsoon from "../pages/page-themes/Utility/pages-comingsoon";
import PagesTimeline from "../pages/page-themes/Utility/pages-timeline";
import PagesFaqs from "../pages/page-themes/Utility/pages-faqs";
import PagesPricing from "../pages/page-themes/Utility/pages-pricing";
import Pages404 from "../pages/page-themes/Utility/pages-404";
import Pages500 from "../pages/page-themes/Utility/pages-500";

//Blog
import BlogList from "../pages/page-themes/Blog/BlogList/index";
import BlogGrid from "../pages/page-themes/Blog/BlogGrid/index";
import BlogDetails from "../pages/page-themes/Blog/BlogDetails";

import NewDepartment from "pages/Authorization/Department/NewDepartment";
import Announcement from "pages/Admin/Settings/Announcement";

//Design
import VVSFormDesign2 from "components/Common/VVSFormDesign2";
import FormDesign from "pages/Design/FormDesign";
import VVSTableDesign2 from "components/Common/VVSTableDesign2";

//Dashboard
import Dashboard from "pages/Dashboard/index";

//Admin
import Employee from "pages/Account/Employee/Employee";
import NewEmployee from "pages/Account/Employee/NewEmployee";
import Department from "pages/Authorization/Department";
import SettingPage from "pages/Admin/Settings";
import Account from "pages/Admin/Account";
import NewAccount2 from "pages/Admin/Account/NewAccount2";
import NewUser from "pages/Users/User/NewUser";

//CRM
import Customer from "pages/CRM/Customer";
import NewCustomer from "pages/CRM/Customer/NewCustomer";
import Lead from "pages/CRM/Lead";
import NewLead from "pages/CRM/Lead/NewLead";
import Branch from "pages/CRM/Branch";
import NewBranch from "pages/CRM/Branch/NewBranch";

//ECommerce
import Selling from "pages/Ecommerce/Selling";
import Order from "pages/Ecommerce/Order";
import NewOrder from "pages/Ecommerce/Selling";
import DetailOrder from "pages/Ecommerce/Order/DetailOrder";
import Promotion from "pages/Ecommerce/Promotion";
import NewPromotion from "pages/Ecommerce/Promotion/Add";
import DetailPromotion from "pages/Ecommerce/Promotion/Detail";
import Voucher from "pages/Ecommerce/Voucher";
import NewVoucher from "pages/Ecommerce/Voucher/NewVoucher";
import Fee from "pages/Ecommerce/Fee/View";

//Product
// import TableProduct from "pages/Product/Products/Product";
// import NewProduct from "pages/Product/Products/NewProduct";
// import ProductCategory from "pages/Product/ProductCategories/View";
// import NewProductCategory from "pages/Product/ProductCategories/NewProductCategory";
// import WareHouse from "pages/Product/Warehouse";
// import Brand from "pages/Product/Brand";
// import Vendor from "pages/Product/Vendor";
// import Stock from "pages/Product/Stock";
// import GoldPrice from "pages/Product/GoldPrice";
import InvestmentPackage from "pages/Product/InvestmentPackage";
import NewInvestmentPackage from "pages/Product/InvestmentPackage/NewInvestmentPackage";

//Saving
import InterestRate from "pages/Saving/InterestRate";
import Contract from "pages/Saving/Contract/View";
import DetailContract from "pages/Saving/Contract/Detail";

// Template
import Template from "pages/Template";
import NewTemplate from "pages/Template/NewTemplate";

// Require
import TransactionMoney from "pages/Require/TransactionMoney";
import TransactionGold from "pages/Require/TransactionGold";
import DetailTransactionMoney from "pages/Require/TransactionMoney/Detail";
import DetailTransactionGold from "pages/Require/TransactionGold/Detail";
import LiquidationRequestedContract from "pages/Require/LiquidationRequestedContract";
import ExtendContract from "pages/Require/ExtendContract";

//News
import Posts from "pages/News/Post";
import NewPosts from "pages/News/Post/NewPosts";
import ListPosts from "pages/News/PostCategory/View";

//Report
import ReportPages from "pages/Report/ReportPage";

// PHL
import User from "pages/PHL/User";
import Question from "pages/PHL/Question";
import DetailQuestion from "pages/PHL/Question/DetailQuestion";

import Commission from "pages/Commission";
import Roles from "pages/Authorization/Roles";
import EmployeeGroup from "pages/Authorization/EmployeeGroup";
import NewEmployeeGroup from "pages/Authorization/EmployeeGroup/NewEmployeeGroup";
import EmployeeGrade from "pages/Authorization/EmployeeGrade";
import NewEmployeeGrade from "pages/Authorization/EmployeeGrade/NewEmployeeGrade";
import Bank from "pages/Account/Bank";
import NewBank from "pages/Account/Bank/NewBank";

//KPI
import Criteria from "pages/KPI/Criteria";
import PendingContract from "pages/Saving/Contract/PendingContract";
import AllotmentLead from "pages/CRM/Lead/AllotmentLead";
import RefferalBonus from "pages/RefferalBonus";
import NewRefferalBonus from "pages/RefferalBonus/NewRefferalBonus";
import ReferralBonusPolicy from "pages/RefferalBonus/Policy";
import NewReferralBonusPolicy from "pages/RefferalBonus/Policy/NewPolicy";
import Investment from "pages/CRM/Investment";
import NewCriteria from "pages/KPI/Criteria/NewCriteria";
import SourceLead from "pages/CRM/Lead/SourceLead";
import KPIAssignment from "pages/KPI/KPIAssignment";
import NewKPIAssignment from "pages/KPI/KPIAssignment/NewKPIAssignment";
import CustomerGroup from "pages/CRM/Customer/Group";
import NewCustomerGroup from "pages/CRM/Customer/Group/NewGroup";
import ManageTypeGroup from "pages/CRM/Customer/Group/ManageTypeGroup";
import KPIManagement from "pages/KPI/Management/KPIManagement";
import ExtensionManagement from "pages/CallCenter/ExtensionManagement";
import CallReport from "pages/CallCenter/CallReport";

// test route
import ReportCustomer from "pages/Report/Customer";
import LeadReportPage from "pages/Test-Report";
import TransactionInterest from "pages/Require/TransactionInterest";
import ExamSession from "pages/PHL/ExamSession";
import Category from "pages/PHL/Category";
import MixingRule from "pages/PHL/MixingRule";
import HistoryLogin from "pages/PHL/HistoryLogin";
import TrainingCategory from "pages/PHL/TrainingCategory";
import NewTrainingCategory from "pages/PHL/TrainingCategory/NewTrainingCategory";
import TrainingTemplate from "pages/PHL/TrainingTemplate";
import NewTrainingTemplate from "pages/PHL/TrainingTemplate/NewTrainingTemplate";
import AccountAdmin from "pages/PHL/AccountAdmin";
import NewAccountAdmin from "pages/PHL/AccountAdmin/NewAccountAdmin";
import PHLProduct from "pages/PHL/PHLProduct";
import NewPHLProduct from "pages/PHL/PHLProduct/NewPHLProduct";
import Product from "pages/PHL/Product";
import NewProduct from "pages/PHL/Product/NewProduct";

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/dashboard-saas", component: DashboardSaas },
  { path: "/dashboard-blog", component: DashboardBlog },
  { path: "/:modelName/form-design", component: FormDesign },
  { path: "/:modelName/form-design-2", component: VVSFormDesign2 },
  { path: "/account/new-account", component: NewAccount2 },
  { path: "/account/:id", component: NewAccount2 },
  //profile
  { path: "/profile", component: UserProfile },

  { path: "/lead", component: Lead },
  { path: "/danh-sach", component: Customer },
  { path: "/danh-sach/new-customer", component: NewCustomer },
  { path: "/danh-sach/:id", component: NewCustomer },
  { path: "/lead/new-lead", component: NewLead },
  { path: "/lead/:id", component: NewLead },
  { path: "/hop-dong", component: Contract },
  { path: "/hop-dong/:id", component: DetailContract },
  { path: "/lead-allotment", component: AllotmentLead },
  { path: "/source-lead", component: SourceLead },

  // PHL
  { path: "/user", component: User },
  { path: "/questions", component: Question },
  { path: "/questions/:id", component: DetailQuestion },
  { path: "/exam-session", component: ExamSession },
  { path: "/category", component: Category },
  { path: "/mixing-rule", component: MixingRule },
  { path: "/history-login", component: HistoryLogin },
  { path: "/training-category", component: TrainingCategory },
  {
    path: "/training-category/new-training-category",
    component: NewTrainingCategory,
  },
  { path: "/training-category/:id", component: NewTrainingCategory },
  { path: "/training-template", component: TrainingTemplate },
  {
    path: "/training-template/new-training-template",
    component: NewTrainingTemplate,
  },
  { path: "/training-template/:id", component: NewTrainingTemplate },
  { path: "/account-admin", component: AccountAdmin },
  { path: "/account-admin/new-account-admin", component: NewAccountAdmin },
  { path: "/account-admin/:id", component: NewAccountAdmin },
  { path: "/product-content", component: PHLProduct },
  { path: "/product-content/new-product-content", component: NewPHLProduct },
  { path: "/product-content/:id", component: NewPHLProduct },
  { path: "/product", component: Product },
  { path: "/product/new-product", component: NewProduct },
  { path: "/product/:id", component: NewProduct },

  //Account
  { path: "/employee", component: Employee },
  { path: "/employee/new-employee", component: NewEmployee },
  { path: "/employee/:id", component: NewEmployee },
  { path: "/bank-account", component: Bank },
  { path: "/bank-account/:id", component: NewBank },
  { path: "/bank-account/new-bank-account", component: NewBank },

  //CMS
  { path: "/post", component: Posts },
  { path: "/post/new-post", component: NewPosts },
  { path: "/post/:id", component: NewPosts },
  // Ecommerce
  { path: "/voucher", component: Voucher },
  { path: "/voucher/new-voucher", component: NewVoucher },
  { path: "/voucher/:id", component: NewVoucher },
  { path: "/order/new-order", component: NewOrder },
  { path: "/order/:id", component: DetailOrder },
  { path: "/order", component: Order },

  { path: "/fee", component: Fee },
  //Selling
  { path: "/selling", component: Selling },

  //chat
  { path: "/chat", component: Chat },

  //File Manager
  { path: "/apps-filemanager", component: FileManager },

  //calendar
  { path: "/calendar", component: Calendar },

  //Ecommerce
  { path: "/ecommerce-products", component: EcommerceProducts },
  { path: "/ecommerce-product-details/:id", component: EcommerceProductDetail },

  { path: "/ecommerce-orders", component: EcommerceOrders },
  { path: "/ecommerce-customers", component: EcommerceCustomers },
  { path: "/ecommerce-cart", component: EcommerceCart },
  { path: "/ecommerce-checkout", component: EcommerceCheckout },
  { path: "/ecommerce-shops", component: EcommerceShops },
  { path: "/ecommerce-add-product", component: EcommerceAddProduct },

  //Email
  { path: "/email-inbox", component: EmailInbox },
  { path: "/email-read", component: EmailRead },
  { path: "/email-template-basic", component: EmailBasicTemplte },
  { path: "/email-template-alert", component: EmailAlertTemplte },
  { path: "/email-template-billing", component: EmailTemplateBilling },

  //Blog
  { path: "/blog-list", component: BlogList },
  { path: "/blog-grid", component: BlogGrid },
  { path: "/blog-details", component: BlogDetails },

  //Charts
  { path: "/apex-charts", component: ChartApex },
  { path: "/chartist-charts", component: ChartistChart },
  { path: "/chartjs-charts", component: ChartjsChart },
  { path: "/e-charts", component: EChart },
  { path: "/sparkline-charts", component: SparklineChart },
  { path: "/charts-knob", component: ChartsKnob },
  { path: "/re-charts", component: ReCharts },

  // Icons
  { path: "/icons-boxicons", component: IconBoxicons },
  { path: "/icons-dripicons", component: IconDripicons },
  { path: "/icons-materialdesign", component: IconMaterialdesign },
  { path: "/icons-fontawesome", component: IconFontawesome },

  // Tables
  { path: "/tables-basic", component: BasicTables },
  { path: "/tables-datatable", component: DatatableTables },
  { path: "/tables-responsive", component: ResponsiveTables },
  { path: "/tables-editable", component: EditableTables },
  { path: "/tables-dragndrop", component: DragDropTables },

  // Maps
  { path: "/maps-google", component: MapsGoogle },
  { path: "/maps-vector", component: MapsVector },
  { path: "/maps-leaflet", component: MapsLeaflet },

  // Forms
  { path: "/form-elements", component: FormElements },
  { path: "/form-layouts", component: FormLayouts },
  { path: "/form-advanced", component: FormAdvanced },
  { path: "/form-editors", component: FormEditors },
  { path: "/form-mask", component: FormMask },
  { path: "/form-repeater", component: FormRepeater },
  { path: "/form-uploads", component: FormUpload },
  { path: "/form-wizard", component: FormWizard },
  { path: "/form-validation", component: FormValidations },
  { path: "/form-xeditable", component: FormXeditable },
  { path: "/dual-listbox", component: DualListbox },

  // Ui
  { path: "/ui-alerts", component: UiAlert },
  { path: "/ui-buttons", component: UiButtons },
  { path: "/ui-cards", component: UiCards },
  { path: "/ui-carousel", component: UiCarousel },
  { path: "/ui-colors", component: UiColors },
  { path: "/ui-dropdowns", component: UiDropdown },
  { path: "/ui-general", component: UiGeneral },
  { path: "/ui-grid", component: UiGrid },
  { path: "/ui-images", component: UiImages },
  { path: "/ui-lightbox", component: UiLightbox },
  { path: "/ui-modals", component: UiModal },
  { path: "/ui-progressbars", component: UiProgressbar },
  { path: "/ui-sweet-alert", component: UiSweetAlert },
  { path: "/ui-tabs-accordions", component: UiTabsAccordions },
  { path: "/ui-typography", component: UiTypography },
  { path: "/ui-video", component: UiVideo },
  { path: "/ui-session-timeout", component: UiSessionTimeout },
  { path: "/ui-rating", component: UiRating },
  { path: "/ui-rangeslider", component: UiRangeSlider },
  { path: "/ui-notifications", component: UiNotifications },
  { path: "/ui-toasts", component: UiToast },
  { path: "/ui-offcanvas", component: UiOffCanvas },
  { path: "/ui-breadcrumb", component: Breadcrumb },
  { path: "/ui-placeholders", component: UiPlaceholders },
  //Utility
  { path: "/pages-starter", component: PagesStarter },
  { path: "/pages-timeline", component: PagesTimeline },
  { path: "/pages-faqs", component: PagesFaqs },
  { path: "/pages-pricing", component: PagesPricing },

  //HR
  { path: "/tk-nhan-vien", component: Employee },
  { path: "/departments", component: Department },
  { path: "/tk-nhan-vien/new-employee", component: NewEmployee },
  { path: "/tk-nhan-vien/:id", component: NewEmployee },
  { path: "/department", component: Department },
  { path: "/department/new-department", component: NewDepartment },
  { path: "/department/:id", component: NewDepartment },
  { path: "/branch", component: Branch },
  { path: "/branch/new-branch", component: NewBranch },
  { path: "/branch/:id", component: NewBranch },

  { path: "/", exact: true, component: () => <Redirect to="/questions" /> },

  { path: "/notification", component: Notification },
  { path: "/account", component: Account },
  {
    path: "/pq-nhom-quyen",
    component: Roles,
  },
  {
    path: "/employee-group",
    component: EmployeeGroup,
  },
  {
    path: "/employee-group/new-employee-group",
    component: NewEmployeeGroup,
  },
  {
    path: "/employee-group/:id",
    component: NewEmployeeGroup,
  },
  {
    path: "/employee-grade",
    component: EmployeeGrade,
  },
  {
    path: "/employee-grade/new-employee-grade",
    component: NewEmployeeGrade,
  },
  {
    path: "/employee-grade/:id",
    component: NewEmployeeGrade,
  },
  {
    path: "/announcement",
    component: Announcement,
  },
  {
    path: "/post-category",
    component: ListPosts,
  },
  {
    path: "/interest-rate",
    component: InterestRate,
  },
  // Promotion
  {
    path: "/promotion",
    component: Promotion,
  },
  {
    path: "/promotion/new-promotion",
    component: NewPromotion,
  },
  {
    path: "/promotion/:id",
    component: DetailPromotion,
  },
  {
    path: "/report",
    component: ReportPages,
  },
  // Require
  {
    path: "/transaction",
    component: TransactionMoney,
  },
  {
    path: "/transaction/:id",
    component: DetailTransactionMoney,
  },
  {
    path: "/transaction-gold",
    component: TransactionGold,
  },
  {
    path: "/transaction-gold/:id",
    component: DetailTransactionGold,
  },
  {
    path: "/liquidation-requested-contract",
    component: LiquidationRequestedContract,
  },
  { path: "/extend-contract", component: ExtendContract },

  {
    path: "/transaction-interest",
    component: TransactionInterest,
  },

  // Template
  {
    path: "/template",
    component: Template,
  },
  {
    path: "/template/new-template",
    component: NewTemplate,
  },
  {
    path: "/template/:id",
    component: NewTemplate,
  },
  //product Invest
  {
    path: "/product",
    component: InvestmentPackage,
  },
  {
    path: "/product/new-product",
    component: NewInvestmentPackage,
  },
  {
    path: "/product/:id",
    component: NewInvestmentPackage,
  },
  {
    path: "/app/:modelName/:id",
    component: VVSTableDesign2,
  },

  {
    path: "/commission",
    component: Commission,
  },

  { path: "/contract", component: Contract },
  { path: "/contract/:id", component: DetailContract },
  { path: "/contract-pending", component: PendingContract },
  { path: "/contract-pending/:id", component: DetailContract },

  {
    path: "/transaction",
    component: TransactionMoney,
  },
  {
    path: "/transaction/:id",
    component: DetailTransactionMoney,
  },

  { path: "/customer", component: Customer },
  { path: "/customer/new-customer", component: NewCustomer },
  { path: "/customer/:id", component: NewCustomer },

  { path: "/customer-group", component: CustomerGroup },
  { path: "/customer-group/new-customer-group", component: NewCustomerGroup },
  { path: "/customer-group/:id", component: NewCustomerGroup },
  { path: "/manage-customer-group-type", component: ManageTypeGroup },

  { path: "/investor", component: Investment },
  { path: "/investor/:id", component: NewCustomer },
  //KPI

  { path: "/kpi", component: Criteria },
  { path: "/kpi/new-kpi", component: NewCriteria },
  { path: "/kpi/:id", component: NewCriteria },

  { path: "/kpi-assignment", component: KPIAssignment },
  { path: "/kpi-assignment/new-kpi-assignment", component: NewKPIAssignment },
  { path: "/kpi-assignment/:id", component: NewKPIAssignment },

  { path: "/kpi-report", component: KPIManagement },
  // test
  {
    path: "/lead-report",
    component: LeadReportPage,
  },

  //Refferal Bonus and Refferal Bonus Policy
  { path: "/refferal-bonus", component: RefferalBonus },
  { path: "/refferal-bonus/:id", component: NewRefferalBonus },

  { path: "/referral-bonus-policy", component: ReferralBonusPolicy },
  {
    path: "/referral-bonus-policy/new-referral-bonus-policy",
    component: NewReferralBonusPolicy,
  },
  {
    path: "/referral-bonus-policy/:id",
    component: NewReferralBonusPolicy,
  },
  //Call Center
  { path: "/extention-management", component: ExtensionManagement },
  { path: "/call-history", component: CallReport },

  {
    path: "/report-customer",
    component: ReportCustomer,
  },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },

  { path: "/pages-maintenance", component: PagesMaintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },

  // Authentication Inner
  { path: "/pages-login", component: Login1 },
  { path: "/pages-login-2", component: Login2 },

  { path: "/pages-register", component: Register1 },
  { path: "/pages-register-2", component: Register2 },

  { path: "/page-recoverpw", component: Recoverpw },
  { path: "/pages-recoverpw-2", component: Recoverpw2 },

  { path: "/pages-forgot-pwd", component: ForgetPwd1 },
  { path: "/pages-forgot-pwd-2", component: ForgetPwd2 },

  { path: "/auth-lock-screen", component: LockScreen },
  { path: "/auth-lock-screen-2", component: LockScreen2 },
  { path: "/page-confirm-mail", component: ConfirmMail },
  { path: "/page-confirm-mail-2", component: ConfirmMail2 },
  { path: "/auth-email-verification", component: EmailVerification },
  { path: "/auth-email-verification-2", component: EmailVerification2 },
  { path: "/auth-two-step-verification", component: TwostepVerification },
  { path: "/auth-two-step-verification-2", component: TwostepVerification2 },
  { path: "*", component: Pages404 },
];

export { authProtectedRoutes, publicRoutes };
